import React, { useState, useEffect, useRef } from 'react'
import { useParams, NavLink, useNavigate } from 'react-router-dom'
import { getData, putData, postData } from '../../../actions/servicesHttp'
import { Toast } from 'primereact/toast'
import Swal from 'sweetalert2'
import SendMessages from '../../../components/modals/sendMessage'
import Mapa from '../../../components/generals/map'
import Header from '../../../components/generals/header'
import ModalApps from '../../../components/modals/modalApps'
import BoxChart from '../../../components/generals/boxCharts'
import LockedDevices from '../../../components/modals/lockeds'
import ModalInforms from '../../../components/modals/modalInforms'
import ModalBackgroundChange from '../../../components/modals/modalBackgroundChange'
import ModalContentDownload from '../../../components/modals/modalContentDownload'
import ModalRSDevice from '../../../components/modals/modalsRxartSecure/modalRSDevice'
import ModalDebugLog from '../../../components/modals/modalsRxartSecure/modalDebugLog'
import ModalSendCommands from '../../../components/modals/modalsRxartSecure/modalSendCommands'
import ModalDeleteFolders from '../../../components/modals/modalsRxartSecure/modalDeleteFolders'
import { formatDate } from '../../../components/generals/charts/utils/DatesFormats'
import { ProgressSpinner } from 'primereact/progressspinner'
import SpeedDialMenu from '../../../components/Dashboards/speedDialMenu'
import infoCard from './JSON/info'
import formatConnections from './Assets/formatConnections'
import styles from '../../../css/Dashboards/DashDevices.module.css'
import stylesIndex from '../../../css/Index.module.css'
import CardsInfo from '../../../components/Dashboards/Devices/cardsInfo'
import CardsStats from '../../../components/Dashboards/Devices/cardsStats'
import store from '../../../reducer/store'
import UnlicensedMessage from '../../../components/generals/UnlicensedMessage'
import { ConnectionManager, Emmiter } from '../../../actions/SoketIoService/ConnectionManager'
import CardsStatsRealTime from '../../../components/Dashboards/Devices/cardsStatsRealTime'
import ModalModifyScreenBrightness from '../../../components/modals/ModalModifyScreenBrightness'
import { Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import ModalEstablishment from '../../../components/modals/ModalEstablishment'
import ModalActivateLicense from '../../../components/modals/ModalActivateLicense'

export default function Dashboard () {
  const { id } = useParams()
  const { user } = store.getState()
  const role = user.roles
  const { t } = useTranslation('dashboardDevice')
  const navigate = useNavigate()

  // ? urls de la API
  const [deviceUrl] = useState('device/data')
  const [preferenceUrl] = useState('preferences')
  const [statUrl] = useState('device/stats')
  const [locationsUrl] = useState('device/last_location')
  const [connectionsUrl] = useState('device/connections')
  const [urlDevicesUseTime] = useState('devicesUseTime')

  // //* estados de componentes
  const [device, setDevice] = useState()
  const [stat, setStat] = useState()
  const [locations, setLocations] = useState()
  const [connections, setConnections] = useState()
  const [preferences, setPreferences] = useState()
  const [deviceUseTime, setDeviceUseTime] = useState()
  const [licence, setLicence] = useState(null)

  const toast = useRef(null)
  const [action, setAction] = useState(null)
  const [labelConn, setLabelConn] = useState()
  const [flagReload, setFlagReload] = useState(false)

  // Estados para mostrar o no los modales
  const [modalsShow, setModalsShow] = useState({
    message: false,
    lockeds: false,
    reports: false,
    apps: false,
    backgroundChange: false,
    contentDownload: false,
    RSDevice: false,
    errorLogs: false,
    sendCommand: false,
    deleteFolders: false,
    modifyScreenBrightness: false,
    establishment: false,
    activateLicense: false
  })
  const [dateFilter, setDateFilter] = useState(7)

  //* Estados ws
  const sok = useRef(ConnectionManager()).current
  const [realTime, setRealTime] = useState(false)
  const [deviceConnect, setDeviceConnect] = useState(false)
  const [clientConnect, setClientConnect] = useState(false)

  // Filtro de fecha
  const dates = [
    { name: t('filters.filter1'), value: 7 },
    { name: t('filters.filter2'), value: 0 }
  ]

  //* se separaron la funcion socket para poder enviar dicha funcion cada componente
  const socketReceiveRam = (setRam) => {
    sok.on('statRam', (res) => {
      // console.log(res)
      setRam(res)
    })
  }
  const socketReceiveDisk = (setDisk) => {
    sok.on('statDisk', (res) => {
      // console.log(res)
      setDisk(res)
    })
  }
  const socketReceiveBattery = (setBattery) => {
    sok.on('statBattery', (res) => {
      // console.log(res)
      setBattery(res?.Battery)
    })
  }
  const socketReceiveLocations = (setLocation, setLabelRealTime) => {
    sok.on('locations', (res) => {
      setLocation(res)
      setLabelRealTime(true)
    })
  }
  const socketReceiveActionsCompleted = (setFlagReload) => {
    sok.on('actionsCompleted', (res) => {
      setFlagReload(true)
    })
  }
  const socketReceiveCommand = (handleReceiveAction) => {
    sok.on('command', (res) => {
      if (typeof handleReceiveAction === 'function') {
        handleReceiveAction(res)
      }
    })
  }
  const socketReceive = () => {
    sok.on('deviceConnect', (res) => {
      // console.log({ res })
      setDeviceConnect(res.device)
    })
    sok.on('clientConnect', (res) => {
      setClientConnect(res.client)
    })
  }

  const socketSendActions = (json) => {
    // console.log(json, 'socketSendActions', device?.licence)

    if (device?.licence) {
      Emmiter(
        sok,
        'actions',
        {
          identity: device?.licence,
          actions: json
        }
      )
    }
    // return json
  }

  //* Efectos ws
  useEffect(() => {
    socketReceive()
  }, [])

  useEffect(() => {
    if (device?.licence) {
      Emmiter(sok, 'openState', { identity: device?.licence, device: true })
      setDeviceConnect(true)
    }
  }, [device?.licence])

  useEffect(() => {
    if (deviceConnect && clientConnect && device?.licence) {
      setRealTime(true)
      Emmiter(sok, 'connectDevice', { identity: device?.licence, state: 'open' })
    } else {
      setRealTime(false)
    }
  }, [deviceConnect, clientConnect, device?.licence])

  //* Llamadas a la API
  useEffect(() => {
    getRequest(deviceUrl, id, setDevice, setLicence)
  }, [deviceUrl, id])
  useEffect(() => {
    if (licence) getRequest(preferenceUrl, 1, setPreferences)
  }, [preferenceUrl, id, licence])
  useEffect(() => {
    if (licence) getRequest(connectionsUrl, id, setConnections)
  }, [connectionsUrl, id, licence])
  useEffect(() => {
    if (licence) {
      getRequest(statUrl, id, setStat)
    }
  }, [statUrl, id, licence])
  useEffect(() => {
    if (licence) {
      getRequest(locationsUrl, id, setLocations)
    }
  }, [locationsUrl, id, licence])

  useEffect(() => {
    if (licence) {
      let startDate = new Date()
      startDate = startDate.setDate(startDate.getDate() - dateFilter)
      startDate = new Date(startDate)?.toISOString().split('T')[0]

      let endDate = new Date()
      endDate = dateFilter === 0 ? endDate.setDate(endDate.getDate() - 0) : endDate.setDate(endDate.getDate() - 1)
      endDate = new Date(endDate)?.toISOString().split('T')[0]

      const date = startDate + ',' + endDate
      getRequest(urlDevicesUseTime, `${date}/${id}`, setDeviceUseTime)
    }
  }, [urlDevicesUseTime, id, licence, dateFilter])

  //* lanza alerta de alarma y hace el disable
  useEffect(() => {
    disabledAlarms(stat)
  }, [stat])

  //* efecto de label de connection
  useEffect(() => {
    if (connections) {
      const label = formatConnections(connections)
      setLabelConn(label)
    }
  }, [connections])

  useEffect(() => {
    getRequest(deviceUrl, id, setDevice, setLicence)
    if (flagReload) setFlagReload(false)
  }, [flagReload])

  // //* llamador de datos de API
  const getRequest = async (url, data, set, setLic) => {
    const response = await getData(url, data, navigate)
    // console.log(response, url)
    if (response?.status === 200) {
      set(response.data)
      if (url === 'device/data') {
        if (response?.data) {
          response.data.last_date = formatDate(response.data.last_date)
        }
        setLic(response.data.licence)
      }
    } else {
      set({ error: true, code: response?.code })
    }
  }

  //* funcion de desactivacion de alarmas por defecto
  async function disabledAlarms (stat) {
    if (stat) {
      if (stat.checkAlert) {
        const json = {
          id: stat.id,
          checkAlert: false
        }

        await putData('stats', json, navigate)

        toast.current.show({
          severity: 'error',
          summary: t('message1'),
          sticky: true
        })
      }
    }
  }

  // ? Va seteando el estado para reenderizar los modales
  function handleModal (type, boolean) {
    if (type === 'bloquear' || type === 'desbloquear') {
      setAction(type)
      setModalsShow({ ...modalsShow, lockeds: boolean })
    } else {
      if (type === 'sendCommand') {
        boolean
          ? Emmiter(sok, 'connectDevice', { identity: device?.licence, state: 'open-cmd' })
          : Emmiter(sok, 'connectDevice', { identity: device?.licence, state: 'close-cmd' })
      }
      setModalsShow({ ...modalsShow, [type]: boolean })
    }
  }

  //* funcion de recarga de device
  const getDevice = async () => {
    await getRequest(deviceUrl, id, setDevice, setLicence)
  }

  //* funcion de modales
  async function deleted (action, data) {
    const jsonAction = {
      touch: action === 'desactivar',
      screen: action === 'desactivar'
    }

    const json = {
      action: 'disable',
      data: {
        statusLock: action === 'desactivar',
        preferences: jsonAction
      },
      devicesId: [parseInt(id)],
      groupsId: []
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons
      .fire({
        title: `${t('message2')} ${action === 'activar' ? t('message3') : t('message4')}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('button1'),
        cancelButtonText: t('button2'),
        reverseButtons: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          if (action === 'desactivar') {
            device.motive_lock = 'disabled'
          } else if (action === 'activar') {
            device.motive_lock = 'activated'
          }

          if (realTime) {
            socketSendActions([json])
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: t('message5'),
              text: `${action === 'activar' ? t('message6') : t('message7')} ${t('message8')}`,
              showConfirmButton: false,
              timer: 2000
            })
          } else {
            const { data } = await postData('actions', [json], navigate)
            if (data[0]?.result) {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: t('message5'),
                text: `${action === 'activar' ? t('message6') : t('message7')} ${t('message8')}`,
                showConfirmButton: false,
                timer: 2000
              })
              // if (data[1]?.sendings.length > 0) setDevice()
            } else {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: t('message9'),
                text: `${action === 'activar' ? t('message6') : t('message7')} ${t('message10')}`,
                showConfirmButton: false,
                timer: 2000
              })
            }
          }
          await putData('device', data, navigate)
          setFlagReload(true)
        }
      })
  }

  async function lockScreenAction (data) {
    const json = {
      action: 'screen_lock',
      data: {
        statusScreenLock: true
      },
      devicesId: [parseInt(id)],
      groupsId: []
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons
      .fire({
        title: t('message11'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('button1'),
        cancelButtonText: t('button2'),
        reverseButtons: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          if (realTime) {
            socketSendActions([json])
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: t('message5'),
              showConfirmButton: false,
              timer: 2000
            })
          } else {
            const { data } = await postData('actions', [json], navigate)
            if (data[0]?.result) {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: t('message5'),
                showConfirmButton: false,
                timer: 2000
              })
              // if (data[1]?.sendings.length > 0) setDevice()
            } else {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: t('message9'),
                showConfirmButton: false,
                timer: 2000
              })
            }
          }
          setFlagReload(true)
        }
      })
  }

  async function missingDeviceAction (action, device) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons
      .fire({
        title: `${t('message12')} ${action === 'add' ? t('message13') : t('message14')} ${t('message15')} ${action === 'add' ? t('message16') : t('message17')} ${t('message18')}`,
        icon: 'warning',
        html: `${action === 'add' ? t('message19') : ''}`,
        showCancelButton: true,
        confirmButtonText: t('button1'),
        cancelButtonText: t('button2'),
        reverseButtons: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          let response
          if (action === 'add') {
            response = await postData('missing-devices', { deviceId: device.id, userId: user.userId })
          } else {
            const today = new Date()
            response = await putData('missing-devices', { deviceId: device.id, closeUserId: user.userId, closeDate: today.toISOString(), status: 'close' }, navigate)
          }
          const res = await putData('device', {
            id: device.id,
            missing: action === 'add'
          }, navigate)
          console.log(res?.data)
          if (response?.data) {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: t('message5'),
              showConfirmButton: false,
              timer: 2000
            })
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: t('message9'),
              showConfirmButton: false,
              timer: 2000
            })
          }

          setFlagReload(true)
        }
      })
  }

  const infoJson = infoCard(role?.dashboardDevicePage)

  const validationToShowSpeedDialButton = (role, device) => {
    let show = false

    const dashboardDevice = Object.keys(role)

    dashboardDevice.forEach((key) => {
      if (key.includes('action') && key !== 'actionRxartSecure') {
        show = true
      } else if (key === 'actionRxartSecure' && device?.id_rxart) {
        show = true
      }
    })

    return show
  }

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>

        <div>
          {licence === null && <UnlicensedMessage />}
          {device && role?.dashboardDevicePage.buttonSpeedDial && validationToShowSpeedDialButton(role?.dashboardDevicePage, device) && licence !== null && (
            <SpeedDialMenu
              onHide={handleModal}
              data={device}
              deleted={deleted}
              type="devices"
              id={id}
              identity={device.identity}
              dashboardDevicePage={role?.dashboardDevicePage}
              socketSendActions={socketSendActions}
              realTime={realTime}
              setDevice={setDevice}
              lockScreenAction={lockScreenAction}
              missingDeviceAction={missingDeviceAction}
            />

          )}
          {device && (
            <div>
              <Toast ref={toast} position="top" />
              <Header
                title={device.name}
                realTime={realTime}
                edit={true}
                data={device}
                type="device"
                reload={getDevice}
              />
            </div>
          )}
          <div>
            <NavLink to="/mdm/devices">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button3')}
              </Button>
            </NavLink>
          </div>
          <section>
            {device && <CardsInfo
              device={device}
              infoCards={infoJson}
              role={role?.dashboardDevicePage}
              socketReceiveActionsCompleted={socketReceiveActionsCompleted}
              realTime={true}
              setFlagReload={setFlagReload}
              onHide1={() => handleModal('establishment', true)}
              onHide2={() => handleModal('activateLicense', true)}
            />}
            {licence !== null && (!realTime) && <CardsStats
              stat={stat}
              preferences={preferences}
              connections={connections}
              labelConn={labelConn}
              role={role}
              deviceUseTime={deviceUseTime}
              dates={dates}
              dateFilter={dateFilter}
              setDateFilter={setDateFilter}
              id={id}
            />}
            {licence !== null && realTime && <CardsStatsRealTime
              funcSokDisk={socketReceiveDisk}
              funcSokRam={socketReceiveRam}
              funcSokBattery={socketReceiveBattery}
              preferences={preferences}
              connections={connections}
              labelConn={labelConn}
              stat={stat}
              role={role}
              deviceUseTime={deviceUseTime}
              dates={dates}
              dateFilter={dateFilter}
              setDateFilter={setDateFilter}
              id={id}
            />}
          </section>
          {role?.dashboardDevicePage.lastLocationMap && licence !== null && <section className={styles.principalSection} style={{ height: '40rem' }}>
            <div className={styles.bodyDash}>
              {role?.dashboardDevicePage.lastLocationMap && <BoxChart
                width="100%"
                title={t('label1')}
                icon="pi pi-map-marker"
                id={id}
                height="39rem"
              >
                {locations === undefined
                  ? (
                    <ProgressSpinner />
                    )
                  : locations?.error || locations.length === 0
                    ? (
                      <h5>{t('label2')}</h5>
                      )
                    : (
                        locations && (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            height: 'auto',
                            alignItems: 'center',
                            position: 'relative'
                          }}
                        >
                          {role?.dashboardDevicePage.moreLocationsButton && <NavLink
                            to={`/mdm/history/${id}`}
                            className={`btn btn-dark ${styles.navLinkLastLocation}`}
                            type="button"
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                              })
                            }}
                          >
                            <i
                              className="pi pi-map-marker"
                              style={{ marginRight: '0.5rem' }}
                            ></i>
                            {t('label3')}
                          </NavLink>}
                          <Mapa
                            realTime={realTime}
                            info={locations?.last_location}
                            funcSokLocation={socketReceiveLocations}
                            type="last"
                          />
                        </div>
                        )
                      )}
              </BoxChart>}
            </div>
          </section>}
          {device && (
            <>
              {/* MODAL APLICACIONES */}
              <ModalApps
                show={modalsShow.apps}
                onHide={() => handleModal('apps', false)}
                type="devices"
                so={device.so}
                identity={device.identity}
                dashboardDevicePage={role?.dashboardDevicePage}
                socketSendActions={socketSendActions}
                realTime={realTime}
              />

              {/* MODAL INFORMES */}
              <ModalInforms
                show={modalsShow.reports}
                onHide={() => handleModal('reports', false)}
                device={device}
              />

              {/* MODAL BLOQUEAR */}
              {preferences && (
                <LockedDevices
                  show={modalsShow.lockeds}
                  onHide={() => handleModal('lockeds', false)}
                  action={action}
                  title={`${t('lockedDevices.label6')} ${action === 'bloquear' ? t('lockedDevices.label20') : action === 'desbloquear' ? t('lockedDevices.label21') : ''} ${t('lockedDevices.label7')}`}
                  devices={[device]}
                  configDefault={preferences?.defaultThief?.default}
                  preferences={preferences?.defaultThief}
                  reload={getDevice}
                  socketSendActions={socketSendActions}
                  realTime={realTime}
                />
              )}

              {/* MODAL ENVIAR MENSAJE */}
              <SendMessages
                title={t('label4')}
                show={modalsShow.message}
                onHide={() => handleModal('message', false)}
                devices={[parseInt(id)]}
                identity={device.licence}
                component="dashboardDevices"
                socketSendActions={socketSendActions}
                realTime={realTime}
              />

              {/* MODAL CAMBIO DE FONDO DE PANTALLA */}
              <ModalBackgroundChange
                show={modalsShow.backgroundChange}
                onHide={() => handleModal('backgroundChange', false)}
                title={t('modalBackgroundChange.title')}
                btnError={t('modalBackgroundChange.button1')}
                btnSuccess={t('modalBackgroundChange.button2')}
                type="devices"
                identity={device.identity}
                socketSendActions={socketSendActions}
                realTime={realTime}
              />

              {/* MODAL MODIFICACIÓN DEL BRILLO */}
              <ModalModifyScreenBrightness
                show={modalsShow.modifyScreenBrightness}
                onHide={() => handleModal('modifyScreenBrightness', false)}
                type="devices"
                title={t('modalModifyScreenBrightness.title')}
                btnError={t('modalModifyScreenBrightness.button1')}
                btnSuccess={t('modalModifyScreenBrightness.button2')}
                socketSendActions={socketSendActions}
                realTime={realTime}
              />

              {/* MODAL DE DESCARGA DE CONTENIDO */}
              <ModalContentDownload
                show={modalsShow.contentDownload}
                onHide={() => handleModal('contentDownload', false)}
                title={t('modalContentDownload.title')}
                btnError={t('modalContentDownload.button1')}
                btnSuccess={t('modalContentDownload.button2')}
                type="devices"
                identity={device.identity}
                socketSendActions={socketSendActions}
                realTime={realTime}
              />

              {/* MODAL DE RXART SECURE DE UN DISPOSITIVO */}
              {<ModalRSDevice
                data={device}
                show={modalsShow.RSDevice}
                onHide={() => handleModal('RSDevice', false)}
                title={t('modalRxartSecure.title')}
                btnError={t('modalRxartSecure.button1')}
                btnSuccess={t('modalRxartSecure.button2')}
              />}

              {/* MODAL DE ESTABLECIMIENTO DE UN DISPOSITIVO */}
              <ModalEstablishment
                data={device}
                show={modalsShow.establishment}
                onHide={() => handleModal('establishment', false)}
                title={t('modalEstablishment.title')}
                btnError={t('modalEstablishment.button1')}
                btnSuccess={t('modalEstablishment.button2')}
                reload={() => setFlagReload(true)}
              />

              {/* MODAL DE ACTIVACION DE LA LICENCIA DE UN DISPOSITIVO */}
              <ModalActivateLicense
                data={device}
                show={modalsShow.activateLicense}
                onHide={() => handleModal('activateLicense', false)}
                title={t('modalActivateLicense.title')}
                btnError={t('modalActivateLicense.button1')}
                btnSuccess={t('modalActivateLicense.button2')}
                reload={() => setFlagReload(true)}
              />

              {/* MODAL DE LOG DE ERRORES */}
              <ModalDebugLog
                show={modalsShow.errorLogs}
                onHide={() => handleModal('errorLogs', false)}
                devices={[parseInt(id)]}
                identity={device.identity}
                component="errorLogs"
              />

              {/* MODAL DE ENVIO DE COMANDOS */}
              <ModalSendCommands
                title={t('modalSendCommands.title')}
                show={modalsShow.sendCommand}
                onHide={() => handleModal('sendCommand', false)}
                devices={[parseInt(id)]}
                identity={device.identity}
                component="sendCommand"
                socketSendActions={socketSendActions}
                socketReceiveActions={socketReceiveCommand}
                realTime={realTime}
              />

              {/* MODAL DE BORRADO DE CARPETAS */}
              <ModalDeleteFolders
                title={t('modalDeleteFolders.title')}
                show={modalsShow.deleteFolders}
                onHide={() => handleModal('deleteFolders', false)}
                btnClose={t('modalDeleteFolders.button1')}
                btnSuccess={t('modalDeleteFolders.button2')}
                devices={[parseInt(id)]}
                identity={device.identity}
                component='deleteFolders'
                socketSendActions={socketSendActions}
                realTime={realTime}
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}
